/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cost_Add_PricesInputs */

const en_cost_add_prices = /** @type {(inputs: Cost_Add_PricesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add prices`)
};

const de_cost_add_prices = /** @type {(inputs: Cost_Add_PricesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preise ergänzen`)
};

/**
* | output |
* | --- |
* | "Add prices" |
*
* @param {Cost_Add_PricesInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const cost_add_prices = /** @type {((inputs?: Cost_Add_PricesInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cost_Add_PricesInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cost_add_prices(inputs)
	return en_cost_add_prices(inputs)
});